export const LAST_USED_PROJECT_KEY = "last-used-project"
